import { render, staticRenderFns } from "./Detail.dementia.excel.vue?vue&type=template&id=67d5c9aa&"
import script from "./Detail.dementia.excel.vue?vue&type=script&lang=js&"
export * from "./Detail.dementia.excel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports